import TenantPage from 'layouts/TenantPage';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { examService } from 'shared/services';
import { loadingActions } from 'store';
import { useAppDispatch } from 'store/store';
import ExamForm from '../compoents/ExamForm';
import { IExam } from '../types';

const initExam: IExam = {
  id: null,
  code: null,
  description: null,
  workstations: [],
  equipment: [],
  products: [],
  regional_code: null
};

export const CreateExam = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const translationPrefix = 'pages.exams.new';

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useAppDispatch();

  const createProduct = async (values) => {
    dispatch(loadingActions.startLoading());
    examService
      .add(values)
      .then(() => {
        enqueueSnackbar('Esame aggiunto con successo', { variant: 'success' });
        navigate('..');
      })
      .catch((error) => {
        const errorMessage =
          error?.response?.data?.detail ||
          error?.message ||
          "Errore durante la creazione dell'esame";
        enqueueSnackbar(errorMessage, { variant: 'error' });
      })
      .finally(() => {
        dispatch(loadingActions.stopLoading());
      });
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <ExamForm exam={initExam} onSubmit={createProduct} />
    </TenantPage>
  );
};

export default CreateExam;
